import { NavLink, useLocation } from 'react-router-dom'
import { Right } from 'src/assets'
import { useId } from 'react'
import { t } from 'i18next'

interface NavbarItemProps {
  name: string
  link: string
}

interface Props {
  name: string
  link: string
  icon?: any
  children?: NavbarItemProps[]
}

const ProfileNavbarMenuItem = ({ name, link, icon: Icon }: Props) => {
  const key = useId()
  const { pathname } = useLocation()
  const isActive = pathname === link
  const classes = [
    'w-full',
    'flex',
    'items-center',
    'gap-[20px]',
    'py-[15px]',
    'px-lg',
    'm-0',
    'transition-all',
    'duration-500',
    'base-normal',
    'group',
    isActive ? 'bg-light-gray' : 'bg-mid-gray',
  ]

  return (
    <NavLink key={key} to={link} className={classes.join(' ')}>
      {Icon && (
        <Icon className='min-w-[20px] min-h-[20px] fill-secondary-text' />
      )}
      <div className='w-full'>{t(name)}</div>
      <Right className='min-w-[20px] min-h-[20px] fill-secondary-text' />
    </NavLink>
  )
}

export default ProfileNavbarMenuItem
